require('!!raw-loader!/builds/1210457/v2/src/index.html');